import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import Keycloak from 'keycloak-js';

if (environment.production) {
  enableProdMode();
} else {
  // keycloakUrl = envDev.KeyClock
}
const browserWindow = window || {};
const browserWindowEnv = browserWindow['__env'] || {};

// var loadheaderCss = function (cssId) {
//     if (!document.getElementById(cssId)) {
//         var head = document.getElementsByTagName('head')[0];
//         var link = document.createElement('link');
//         link.id = cssId;
//         link.rel = 'stylesheet';
//         link.type = 'text/css';
//         link.href =  "assets/cdn/css/header.scss"
//         link.media = 'all';
//         head.appendChild(link);
//     } else {
//         var element = <HTMLInputElement>document.getElementById(cssId);
//         element.disabled = true;
//     }
// }

// loadheaderCss("HeaderCss");

async function initializeApp() {
  const initOptions = {
    url: browserWindowEnv.keycloakUrl,
    realm: browserWindowEnv.keycloakRealm,
    clientId: browserWindowEnv.keycloakClientId,
  };
  const keycloak = new Keycloak(initOptions);
  const authenticated = await keycloak.init({ onLoad: 'login-required' });
  if (!authenticated) {
    window.location.reload();
  }
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));

  localStorage.setItem('access-token', keycloak.token);
  localStorage.setItem('refresh-token', keycloak.refreshToken);
  localStorage.setItem('idToken', keycloak.idToken);

  const tokenRefreshInterval = setInterval(async () => {
    try {
      const updateToken = await keycloak.updateToken(100);
      if (updateToken) {
        localStorage.setItem('access-token', keycloak.token);
        localStorage.setItem('refresh-token', keycloak.refreshToken);
        localStorage.setItem('idToken', keycloak.idToken);
        console.debug('Token refreshed' + updateToken);
      } else {
        console.warn(
          'Token not refreshed, valid for ' +
            Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) +
            ' seconds',
        );
      }
    } catch (error) {
      clearInterval(tokenRefreshInterval);
      console.error('Token refresh failed - session expired', error);
      window.dispatchEvent(new CustomEvent('token-expired'));
    }
  }, 1440000);
}

initializeApp();

// platformBrowserDynamic().bootstrapModule(AppModule);
